const selectors = {
  dialog: 'dialog',
  focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
  buttonModalOpen: '[data-modal-open]',
  buttonModalClose: '[data-modal-close]',
};

const attributes = {
  closing: 'closing',
};

class ProductModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.modal = this.querySelector(selectors.dialog);
    this.buttonModalOpen = this.querySelector(selectors.buttonModalOpen);
    this.buttonModalClose = this.querySelector(selectors.buttonModalClose);
    this.focusTarget = this.modal.querySelector('[autofocus]') || this.modal.querySelector(selectors.focusable);
    this.isAnimating = false;

    this.modalEvents();
  }

  modalOpen() {
    // Check if browser supports Dialog tags
    if (typeof this.modal.showModal === 'function') {
      this.modal.showModal();
    }

    this.modal.setAttribute('open', true);
    this.modal.removeAttribute('inert');

    this.focusTarget?.focus();

    document.dispatchEvent(new CustomEvent('theme:modal:open', {bubbles: true}));
  }

  modalClose() {
    if (this.isAnimating) {
      return;
    }

    if (!this.modal.hasAttribute(attributes.closing)) {
      this.modal.setAttribute(attributes.closing, '');
      this.isAnimating = true;
      return;
    }

    // Check if browser supports Dialog tags
    if (typeof this.modal.close === 'function') {
      this.modal.close();
    } else {
      this.modal.removeAttribute('open');
    }

    this.modal.removeAttribute(attributes.closing);
    this.modal.setAttribute('inert', '');
  }

  modalEvents() {
    // Open modal on button click event
    this.buttonModalOpen.addEventListener('click', (e) => {
      e.preventDefault();
      this.modalOpen();
    });

    // Close button click event
    this.buttonModalClose.addEventListener('click', (e) => {
      e.preventDefault();
      this.modalClose();
    });

    // Close dialog on click outside content
    this.modal.addEventListener('click', (event) => {
      if (event.target.nodeName === 'DIALOG' && event.type === 'click') {
        this.modalClose();
      }
    });

    // Close dialog on click ESC key pressed
    this.modal.addEventListener('keydown', (event) => {
      if (event.code == 'Escape') {
        event.preventDefault();
        this.modalClose();
      }
    });

    this.modal.addEventListener('theme:modal:close', () => {
      this.modalClose();
    });

    // Close dialog after animation completes
    this.modal.addEventListener('animationend', (event) => {
      if (event.target !== this.modal) return;
      this.isAnimating = false;

      if (this.modal.hasAttribute(attributes.closing)) {
        this.modalClose();
      }
    });
  }
}

export {ProductModal};
